// import arrowDownGray from "@/assets/images/user/arrowDownGray.svg";
// import schedule1 from "@/assets/images/user/schedule1.jpg";
// import schedule2 from "@/assets/images/user/schedule2.jpg";
// import scheduleArtLogo from "@/assets/images/user/scheduleArtLogo.svg";
// import scheduleLogo1 from "@/assets/images/user/scheduleLogo1.svg";
// import scheduleLogo2 from "@/assets/images/user/scheduleLogo2.svg";
// import scheduleLogo3 from "@/assets/images/user/scheduleLogo3.svg";
// import scheduleLogo4 from "@/assets/images/user/scheduleLogo4.svg";
// import tableArt from "@/assets/images/user/tableArt.svg";
// import tableDay1 from "@/assets/images/user/tableDay1.svg";
// import tableDay2 from "@/assets/images/user/tableDay2.svg";
// import tableFesta from "@/assets/images/user/tableFesta.svg";
// import tableFocus from "@/assets/images/user/tableFocus.svg";
// import tablePlay from "@/assets/images/user/tablePlay.svg";
// import tableStage1 from "@/assets/images/user/tableStage1.svg";
// import tableStage2 from "@/assets/images/user/tableStage2.svg";
import ComingSoon from "@/components/user/common/ComingSoon";
import SubTitle from "@/components/user/common/SubTitle";
import TitleBox from "@/components/user/common/TitleBox";
// import ImgZoomPop from "@/components/user/popup/ImgZoomPop";

export default function Schedule() {
    // const baseBoxClass =
    //     "font-['GongGothicMedium'] text-center h-full flex flex-col items-center bg-white rounded-[8px] transition-all duration-100 relative before:content-[''] before:absolute before:inset-0 before:w-full before:h-full before:rounded-[8px] before:transition-all before:duration-[50ms] before:border-2 hover:before:border-4";
    // const stageBoxClass = `${baseBoxClass} gap-[8px] justify-center before:border-[#FF5B2E] hover:bg-[#FEF7F6]`;
    // const playBoxClass = `${baseBoxClass} gap-[4px] pt-[220px] before:border-[#00A8A0] hover:bg-[#FAFFFF]`;
    // const artBoxClass = `${baseBoxClass} gap-[4px] pt-[220px] before:border-[#EB008B] hover:bg-[#FFF8FC]`;
    // const focusBoxClass = `${baseBoxClass} gap-[4px] justify-center before:border-[#F6921E] hover:bg-[#FFF8EF]`;
    // const festaBoxClass = `${baseBoxClass} gap-[4px] pt-[220px] before:border-[#006AC1] hover:bg-[#F7FBFF]`;
    // const stageTextClass = "bg-gradient-to-r from-[#FF5B2E] to-[#FF7F71] bg-clip-text text-transparent";
    // const playTextClass = "bg-gradient-to-r from-[#00A8A0] to-[#00B8BB] bg-clip-text text-transparent";
    // const artTextClass = "bg-gradient-to-r from-[#EB008B] to-[#EE579E] bg-clip-text text-transparent";
    // const focusTextClass = "bg-gradient-to-r from-[#F6921E] to-[#F9A643] bg-clip-text text-transparent";
    // const festaTextClass = "bg-gradient-to-r from-[#006AC1] to-[#209CEF] bg-clip-text text-transparent";

    return (
        <div className="max-w-[1400px] w-full mx-auto px-[20px] xl:px-0">
            <TitleBox title="SCHEDULE" text="행사 스케줄" />
            <div className="flex flex-col gap-[40px] p-[28px_0_60px] md:p-[48px_0_100px] md:gap-[100px] xl:pb-[160px]">
                <div className="flex flex-col gap-[20px] md:gap-[28px] xl:gap-[40px]">
                    <SubTitle title="1일차 타임테이블" />
                    <ComingSoon />
                    {/* <div className="relative hidden xl:block">
                        <table>
                            <colgroup>
                                <col className="w-[11.4%]" />
                                <col className="w-[14.6%]" />
                                <col className="w-[14.6%]" />
                                <col className="w-[14.3%]" />
                                <col className="w-[14.3%]" />
                                <col className="w-[14.3%]" />
                                <col className="w-[14.3%]" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th className="pb-[12px] border-b border-[#ddd]">
                                        <img src={tableDay1} alt="day1" />
                                    </th>
                                    <th className="p-[0_0_12px_8px] border-b border-[#ddd]" colSpan={2}>
                                        <img src={tableStage1} alt="the stage" className="w-full" />
                                    </th>
                                    <th className="p-[0_0_12px_6px] border-b border-[#ddd]">
                                        <img src={tablePlay} alt="the play" />
                                    </th>
                                    <th className="p-[0_0_12px_6px] border-b border-[#ddd]">
                                        <img src={tableArt} alt="the art" />
                                    </th>
                                    <th className="p-[0_0_12px_6px] border-b border-[#ddd]">
                                        <img src={tableFocus} alt="the focus" />
                                    </th>
                                    <th className="p-[0_0_12px_6px] border-b border-[#ddd]">
                                        <img src={tableFesta} alt="the festa" />
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        10:00 - 13:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[8px]"></td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[8px]"></td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[8px]"></td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[8px]"></td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]" rowSpan={5}>
                                        <div className={focusBoxClass}>
                                            <p className="text-[20px]">GXG 컨퍼런스</p>
                                            <img src={arrowDownGray} alt="화살표" />
                                            <div className={`text-[18px] ${focusTextClass}`}>
                                                <p>
                                                    GXG 2025 컨퍼런스 <br />
                                                    NEXT PLAY <br />
                                                    with Microsoft <br />
                                                    Cloud & AI
                                                </p>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[8px]"></td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        13:00 - 14:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[8px]"></td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]">
                                        <div className={stageBoxClass}>
                                            <img src={scheduleArtLogo} alt="이미지" />
                                            <p className="text-[20px]">GXG 씨어터</p>
                                        </div>
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]" rowSpan={8}>
                                        <div className={playBoxClass}>
                                            <p className="text-[20px]">체험 프로그램</p>
                                            <img src={arrowDownGray} alt="화살표" />
                                            <div className={`flex flex-col gap-[24px] text-[18px] ${playTextClass}`}>
                                                <p>브랜드 체험존</p>
                                                <p>GXG 마켓</p>
                                                <p>GXG 플레이 라운지</p>
                                                <p>
                                                    Cool Station <br />
                                                    with 동아오츠카
                                                </p>
                                                <p>GXG 캠퍼스 아케이드</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]" rowSpan={8}>
                                        <div className={artBoxClass}>
                                            <p className="text-[20px]">전시 프로그램</p>
                                            <img src={arrowDownGray} alt="화살표" />
                                            <div className={`flex flex-col gap-[24px] text-[18px] ${artTextClass}`}>
                                                <p>GXG 씨어터</p>
                                                <p>GXG 아트북 라운지</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]" rowSpan={8}>
                                        <div className={festaBoxClass}>
                                            <p className="text-[20px]">GXG 콜라보레이션</p>
                                            <img src={arrowDownGray} alt="화살표" />
                                            <div className={`flex flex-col gap-[24px] text-[18px] ${festaTextClass}`}>
                                                <div className="flex flex-col items-center gap-[4px]">
                                                    <img src={scheduleLogo1} alt="이미지" />
                                                    <p>인디게임 전시</p>
                                                </div>
                                                <div className="flex flex-col items-center gap-[4px]">
                                                    <img src={scheduleLogo2} alt="이미지" />
                                                    <p>서브컬쳐 이벤트</p>
                                                </div>
                                                <div className="flex flex-col items-center gap-[4px]">
                                                    <img src={scheduleLogo3} alt="이미지" />
                                                    <p>로컬 브랜드 마켓</p>
                                                </div>
                                                <div className="flex flex-col items-center gap-[4px]">
                                                    <img src={scheduleLogo4} alt="이미지" />
                                                    <p>진로탐색 프로그램</p>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        14:00 - 15:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[8px]"></td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]" rowSpan={7}>
                                        <div className={stageBoxClass}>
                                            <p className="text-[20px]">GXG 버스킹 타임</p>
                                            <div className={`text-[18px] flex flex-col gap-[16px] ${stageTextClass}`}>
                                                <p>일러스타 DJ 커넥트 쁘띠</p>
                                                <p>직장인 밴드</p>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        15:00 - 16:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[8px]"></td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        16:00 - 17:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[8px]"></td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        17:00 - 18:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[8px] align-bottom">
                                        <div className={`${stageBoxClass} !h-[calc(100%-40px)] !gap-0`}>
                                            <p className="text-[20px]">사전 공연</p>
                                            <p className={`text-[18px] ${stageTextClass}`}>밴드 리프(Lif)</p>
                                        </div>
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]"></td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        18:00 - 19:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[8px]">
                                        <div className={stageBoxClass}>
                                            <p className="text-[20px]">
                                                GXG 2025 <br />
                                                개막식&축하 공연
                                            </p>
                                            <p className={`text-[18px] ${stageTextClass}`}>에일리</p>
                                        </div>
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]"></td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        19:00 - 20:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[8px] align-top" rowSpan={3}>
                                        <div className={`${stageBoxClass} !h-[calc(100%-30px)]`}>
                                            <p className="text-[18px] leading-[1.5]">
                                                GXG 2025 <br />
                                                게임음악 경연대회 <br />
                                                <span className="flex items-start justify-center">
                                                    The 2
                                                    <span className="text-[13px] font-['GongGothicLight']">nd</span>
                                                    &nbsp;GXG
                                                </span>
                                                SOUND TRACK
                                            </p>
                                        </div>
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]"></td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        20:00 - 21:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]"></td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        21:00 - 22:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px] align-top">
                                        <div className={`${stageBoxClass} !h-[calc(100%-30px)]`}>
                                            <img src={scheduleArtLogo} alt="이미지" />
                                            <p className="text-[20px]">GXG 씨어터</p>
                                        </div>
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]" colSpan={4}></td>
                                </tr>
                            </tbody>
                        </table>
                        <p className="text-[18px] font-['GongGothicMedium'] absolute bottom-[20px] right-[20px]">
                            * 프로그램 시간은 현장 상황에 따라 변동될 수 있습니다.
                        </p>
                    </div>
                    <div className="xl:hidden">
                        <ImgZoomPop img={schedule1} />
                    </div> */}
                </div>
                <div className="flex flex-col gap-[20px] md:gap-[28px] xl:gap-[40px]">
                    <SubTitle title="2일차 타임테이블" />
                    <ComingSoon />
                    {/* <div className="relative hidden xl:block">
                        <table>
                            <colgroup>
                                <col className="w-[11.4%]" />
                                <col className="w-[21.9%]" />
                                <col className="w-[21.9%]" />
                                <col className="w-[14.3%]" />
                                <col className="w-[14.3%]" />
                                <col className="w-[14.3%]" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th className="pb-[12px] border-b border-[#ddd]">
                                        <img src={tableDay2} alt="day2" />
                                    </th>
                                    <th className="p-[0_0_12px_8px] border-b border-[#ddd]" colSpan={2}>
                                        <img src={tableStage2} alt="the stage" className="w-full" />
                                    </th>
                                    <th className="p-[0_0_12px_6px] border-b border-[#ddd]">
                                        <img src={tablePlay} alt="the play" />
                                    </th>
                                    <th className="p-[0_0_12px_6px] border-b border-[#ddd]">
                                        <img src={tableArt} alt="the art" />
                                    </th>
                                    <th className="p-[0_0_12px_6px] border-b border-[#ddd]">
                                        <img src={tableFesta} alt="the festa" />
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        12:00 - 13:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[8px]" rowSpan={3}>
                                        <div className={stageBoxClass}>
                                            <p className="text-[20px]">
                                                일러스타 페스 <br />
                                                스테이지
                                            </p>
                                            <p className={`text-[18px] ${stageTextClass}`}>코스플레이 & 인디아이돌</p>
                                        </div>
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]"></td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]"></td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]"></td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]"></td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        13:00 - 14:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px] align-top" rowSpan={2}>
                                        <div className={`${stageBoxClass} !h-[calc(100%+46px)]`}>
                                            <img src={scheduleArtLogo} alt="이미지" />
                                            <p className="text-[20px]">GXG 씨어터</p>
                                        </div>
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]" rowSpan={8}>
                                        <div className={playBoxClass}>
                                            <p className="text-[20px]">체험 프로그램</p>
                                            <img src={arrowDownGray} alt="화살표" />
                                            <div className={`flex flex-col gap-[24px] text-[18px] ${playTextClass}`}>
                                                <p>브랜드 체험존</p>
                                                <p>GXG 마켓</p>
                                                <p>GXG 플레이 라운지</p>
                                                <p>
                                                    Cool Station <br />
                                                    with 동아오츠카
                                                </p>
                                                <p>GXG 캠퍼스 아케이드</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]" rowSpan={8}>
                                        <div className={artBoxClass}>
                                            <p className="text-[20px]">전시 프로그램</p>
                                            <img src={arrowDownGray} alt="화살표" />
                                            <div className={`flex flex-col gap-[24px] text-[18px] ${artTextClass}`}>
                                                <p>GXG 씨어터</p>
                                                <p>GXG 아트북 라운지</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]" rowSpan={8}>
                                        <div className={festaBoxClass}>
                                            <p className="text-[20px]">GXG 콜라보레이션</p>
                                            <img src={arrowDownGray} alt="화살표" />
                                            <div className={`flex flex-col gap-[24px] text-[18px] ${festaTextClass}`}>
                                                <div className="flex flex-col items-center gap-[4px]">
                                                    <img src={scheduleLogo1} alt="이미지" />
                                                    <p>인디게임 전시</p>
                                                </div>
                                                <div className="flex flex-col items-center gap-[4px]">
                                                    <img src={scheduleLogo2} alt="이미지" />
                                                    <p>서브컬쳐 이벤트</p>
                                                </div>
                                                <div className="flex flex-col items-center gap-[4px]">
                                                    <img src={scheduleLogo3} alt="이미지" />
                                                    <p>로컬 브랜드 마켓</p>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        14:00 - 15:00
                                    </td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        15:00 - 16:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px] align-top" rowSpan={2}>
                                        <div className={`${stageBoxClass} mt-[46px]`}>
                                            <p className="text-[20px]">
                                                GXG <br />
                                                플레이 타임
                                            </p>
                                        </div>
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px] align-bottom" rowSpan={6}>
                                        <div className={`${stageBoxClass} !h-[calc(100%-46px)]`}>
                                            <p className="text-[20px]">GXG 버스킹 타임</p>
                                            <div className={`text-[18px] flex flex-col gap-[16px] ${stageTextClass}`}>
                                                <p>일러스타 DJ 커넥트 쁘띠</p>
                                                <p>직장인 밴드</p>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        16:00 - 17:00
                                    </td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        17:00 - 18:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]"></td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        18:00 - 19:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[8px] align-top" rowSpan={4}>
                                        <div className={`${stageBoxClass} !h-[calc(100%-77px)] mt-[46px]`}>
                                            <p className="text-[20px]">GXG 갈라 콘서트</p>
                                            <div className={`text-[18px] flex flex-col gap-[16px] ${stageTextClass}`}>
                                                <p>앙상블 힐</p>
                                                <p>플래직 콰이어</p>
                                                <p>GXG SOUND TRACK</p>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        19:00 - 20:00
                                    </td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        20:00 - 21:00
                                    </td>
                                </tr>
                                <tr className="bg-[#F8F8F8]">
                                    <td className="h-[100px] text-[18px] font-['GongGothicLight'] text-center border-b border-[#ddd]">
                                        21:00 - 22:00
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px] align-top">
                                        <div className={`${stageBoxClass} !h-[calc(100%-30px)]`}>
                                            <img src={scheduleArtLogo} alt="이미지" />
                                            <p className="text-[20px]">GXG 씨어터</p>
                                        </div>
                                    </td>
                                    <td className="h-[100px] border-b border-[#ddd] pl-[6px]" colSpan={3}></td>
                                </tr>
                            </tbody>
                        </table>
                        <p className="text-[18px] font-['GongGothicMedium'] absolute bottom-[20px] right-[20px]">
                            * 프로그램 시간은 현장 상황에 따라 변동될 수 있습니다.
                        </p>
                    </div>
                    <div className="xl:hidden">
                        <ImgZoomPop img={schedule2} />
                    </div> */}
                </div>
            </div>
        </div>
    );
}
